import {useRef, useState} from 'react';
import {useQueryClient} from 'react-query';

import {SetupProjectQueryKey} from 'src/lib/api/setupWizard';

export function useSetupMutation(queryKey: SetupProjectQueryKey) {
  const queryClient = useQueryClient();
  const [mutatingAction, setMutatingAction] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const mutatingRef = useRef(false);
  const [lastCliCommand, setLastCliCommand] = useState<string | undefined>(undefined);

  const clearError = () => setError(null);

  const mutate = async <T>(actionKey: string, fn: () => Promise<T>): Promise<T | undefined> => {
    if (mutatingRef.current) return undefined;
    mutatingRef.current = true;
    setMutatingAction(actionKey);
    clearError();
    setLastCliCommand(undefined);
    try {
      const result = await fn();
      // Extract cliCommand from result if present
      if (result && typeof result === 'object' && 'cliCommand' in result) {
        setLastCliCommand((result as {cliCommand?: string}).cliCommand);
      }
      await queryClient.invalidateQueries(queryKey);
      return result;
    } catch (e) {
      const msg = e instanceof Error ? e.message : 'Request failed';
      setError(msg);
      return undefined;
    } finally {
      mutatingRef.current = false;
      setMutatingAction(null);
    }
  };

  return {
    mutate,
    mutatingAction,
    isMutating: mutatingAction !== null,
    error,
    clearError,
    lastCliCommand,
  };
}
